import React from 'react'
import { TaskT } from 'ui-io/task-io/task-t'
import { useMutation, useQueryClient } from 'react-query'
import { taskUnblockMutation } from 'ui-io/queries/tasks/task-block-mutation'
import { delay } from 'ui-lib/delay'
// import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/tasks-query'
import { ThemedDialog } from 'ui-components'
import { Button, Classes } from '@blueprintjs/core'
import * as t from 'io-ts'

import toasts from '../../utils/toasts'
import useVerification from '../use-verification'
import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/task-query'

const UnblockTaskDialog = ({
  task,
  isModalOpen,
  toggleModal,
}: {
  task: TaskT
  isModalOpen: boolean
  toggleModal: () => void
}) => {
  const { validator, isValidated, handleOnReset } = useVerification({
    toValidate: task.id,
  })
  const handleOnClosing = () => {
    handleOnReset()
  }
  const queryClient = useQueryClient()
  const mutation = useMutation(taskUnblockMutation, {
    onSuccess: async (result) => {
      if (t.type({ failure: t.string }).is(result[0])) {
        toasts.error(result[0].failure)
      } else {
        toasts.success('Successfully unblocked the task')
      }
      await delay(500)
      queryClient.refetchQueries([TASKS_QUERY_FILTER])
    },
    onError: (error) => {
      toasts.error(`Error: ${error}`)
    },
    onSettled: () => {
      toggleModal()
    },
  })
  const handleUnblockClick = () => {
    mutation.mutate({ taskIds: [task.id] })
  }
  return (
    <ThemedDialog
      isOpen={mutation.isLoading || isModalOpen}
      title="Unblock"
      onClose={toggleModal}
      onClosing={handleOnClosing}
      icon="unlock"
    >
      <div className={Classes.DIALOG_BODY}>
        You are about to unblock this task. If you are sure that this is what
        you you want to do, please type in the last five characters of the task
        ID:
        {validator}
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={toggleModal} disabled={mutation.isLoading}>
            Cancel
          </Button>
          <Button
            intent="primary"
            disabled={!isValidated}
            loading={mutation.isLoading}
            onClick={handleUnblockClick}
          >
            Confirm
          </Button>
        </div>
      </div>
    </ThemedDialog>
  )
}

export default UnblockTaskDialog
